<template>
    <checkout-step step-num="3" :step="step" stepName="Sender Details" @continue="validate" @edit="$emit('edit')">
        <div slot="active">

            <b-field grouped>
                <b-field label="Sender Name" expanded>
                    <b-input type="text" name="sender_fname" placeholder="First Name" expanded v-model.trim="data.sender_fname" v-validate="{required: true, min: 1, max: 255}"></b-input>
                </b-field>
                <b-field expanded label=".">
                    <b-input type="text" name="sender_lname" placeholder="Last Name" expanded v-model.trim="data.sender_lname" v-validate="{required: true, min: 1, max: 255}"></b-input>
                </b-field>
            </b-field>

            <b-field :message="errors.first('sender_cell')" label="Sender cell number">
                <b-input type="text" name="sender_cell" placeholder="(204) 123 - 4567" v-model="data.sender_cell" v-validate="{required: true, phone: true}"></b-input>
            </b-field>
            <b-field :message="errors.first('sender_phone')" label="Sender phone number">
                <b-input type="text" name="sender_phone" placeholder="(204) 123 - 4567" v-model="data.sender_phone" v-validate="{phone: true}"></b-input>
            </b-field>
            <b-field :message="errors.first('sender_email')" label="Sender email">
                <b-input type="email" placeholder="emailaddress@mail.com" v-model.trim="data.sender_email" name="sender_email" v-validate="{required: true, email: true}"></b-input>
            </b-field>
                        
        </div>
        <div slot="finished">
            <p>{{ data.sender_fname }} {{ data.sender_lname }}</p>

            <p>{{ data.sender_cell }}</p>
            <p>{{ data.sender_phone }}</p>
            <p>{{ data.sender_email }}</p>

        </div>
    </checkout-step>
</template>

<script>
import CheckoutStep from '../CheckoutStep';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker';
import BField from 'buefy/src/components/field/Field';
import BInput from 'buefy/src/components/input/Input';
import { parse, asYouType } from 'libphonenumber-js';

export default {
  components: {
    BInput,
    BField,
    BDatepicker,
    CheckoutStep,
  },

  data() {
    const today = new Date();

    return {
      date: new Date(),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),

//      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14),
      maxDate: new Date(today.getFullYear(), today.getMonth() + 2, today.getDate()),

    };
  },

  name: 'checkout-step3',

  props: ['data', 'step'],

  methods: {
    validate() {
      this.$validator.validateAll().then((valid) => {
        if (valid) this.$emit('valid');
      });
    },
  },

  watch: {
    'data.sender_phone'() {
      this.data.sender_phone = new asYouType('CA').input(this.data.sender_phone);
    },
    'data.sender_cell'() {
      this.data.sender_cell = new asYouType('CA').input(this.data.sender_cell);
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout-steps/CheckoutStep3.vue